<div class="background" [class.right]="direction() === 'right'" [style.background]="backgroundColor()">
    @if (progressPercent() > 0)
    {
        <div class="bar" [style.width.%]="progressPercent()" [style.background]="barColor()"></div>
    }
</div>
